import React, { ReactNode } from "react";
import { StyleSheet, View, Text } from "react-native";
import { semanticColors } from "../../../../styles/design-system";

interface WorkspaceHeaderProps {
  title: string;
  badge?: string;
  badgeColor?: string;
  middleAction?: ReactNode;
  actions?: ReactNode[];
}

export const WorkspaceHeader = ({
  title,
  actions,
  badge,
  badgeColor = "#f2f4f7",
  middleAction,
}: WorkspaceHeaderProps) => {
  return (
    <View style={styles.workspaceHeader}>
      <View style={styles.titleWrapper}>
        <Text style={styles.titleText}>{title}</Text>
        {badge != null && (
          <View style={[styles.badge, { backgroundColor: badgeColor }]}>
            <Text style={styles.badgeContent}>{badge}</Text>
          </View>
        )}
      </View>
      {middleAction != null && middleAction}
      <View style={styles.actionRow}>{actions != null && actions.map((action) => action)}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  workspaceHeader: {
    position: "relative",
    width: "100%",
    borderBottomWidth: 1,
    borderBottomColor: "#eaecf0",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 24,
    height: 57,
    backgroundColor: semanticColors.surface.white,
  },
  titleWrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  titleText: {
    fontWeight: 600,
    color: "#101828",
    fontSize: 20,
    lineHeight: 30,
  },
  badge: {
    borderRadius: 9999,
    paddingHorizontal: 10,
    paddingVertical: 2,
    backgroundColor: "#f2f4f7",
    lineHeight: 20,
  },
  badgeContent: {
    fontWeight: 600,
    color: "#101828",
    fontSize: 12,
  },
  actionRow: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "row",
    gap: 12,
    alignContent: "center",
  },
});
